// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2aC4i","tab":"ProcedureTabs_tab__2xWZv"};